import { CheckIcon, Combobox, Group, Indicator, Input, Pill, PillsInput, Text, useCombobox } from "@mantine/core";
import { useEffect, useState } from "react";
import { getStatusColor } from "utils/helper";
import styles from './StatusSelect.module.scss';

const StatusSelectBox = ({data,defaultValue=[],onChange,searchable}) => {
    const combobox = useCombobox({
      onDropdownClose: () => combobox.resetSelectedOption(),
      onDropdownOpen: () => combobox.updateSelectedOptionIndex("active"),
    });
  
    const [search, setSearch] = useState("");
    const [value, setValue] = useState(defaultValue);
  
    const handleValueSelect = (val) =>
      setValue((current) =>
        current.includes(val)
          ? current.filter((v) => v !== val)
          : [...current, val]
      );
  
    const handleValueRemove = (val) =>
      setValue((current) => current.filter((v) => v !== val));
  
    const values = value.map((item) => (
      <Pill className={styles.pill} key={item} withRemoveButton onRemove={() => handleValueRemove(item)} >
        <Group>
            <Indicator
              zIndex={2}
              position="middle-start"
              color={item.length?getStatusColor(item):'gray'}
            >
              <Text style={{ paddingLeft: 12 }} tt="uppercase" fw={700} size="xs">
                {item.length?item:'Not yet actioned'}
              </Text>
            </Indicator>
          </Group>
      </Pill>
    ));
  
    useEffect(() => {
      onChange(value)
    },[value])
  
    const options = data
      .filter((item) => item.toLowerCase().includes(search.trim().toLowerCase()))
      .map((item) => {
        
        if(item.length){
            return (
                <Combobox.Option value={item} key={item} active={value.includes(item)}>
                  <Group>
                    {value.includes(item) ? <CheckIcon size={12} /> : null}
                    <Indicator
                      zIndex={2}
                      position="middle-start"
                      color={getStatusColor(item)}
                    >
                      <Text style={{ paddingLeft: 12 }} tt="uppercase" fw={700} size="xs">
                        {item}
                      </Text>
                    </Indicator>
                  </Group>
                </Combobox.Option>
              )
        }else{
            return (
                <Combobox.Option value={item} key={item} active={value.includes(item)}>
                  <Group>
                    {value.includes(item) ? <CheckIcon size={12} /> : null}
                    <Indicator
                      zIndex={2}
                      position="middle-start"
                      color={'gray'}
                    >
                      <Text style={{ paddingLeft: 12 }} tt="uppercase" fw={700} size="xs">
                        Not yet actioned
                      </Text>
                    </Indicator>
                  </Group>
                </Combobox.Option>
              )
        }
        });
  

    return (
      <Combobox store={combobox} onOptionSubmit={handleValueSelect} withinPortal={false}>
        <Combobox.DropdownTarget>
          <PillsInput onClick={() => combobox.openDropdown()}>
            <Pill.Group>
              {values}
                {searchable?
                <Combobox.EventsTarget>
                <PillsInput.Field
                  onFocus={() => combobox.openDropdown()}
                  onBlur={() => combobox.closeDropdown()}
                  value={search}
                  placeholder="Search values"
                  onChange={(event) => {
                    combobox.updateSelectedOptionIndex();
                    setSearch(event.currentTarget.value);
                  }}
                  onKeyDown={(event) => {
                    if (
                      event.key === "Backspace" &&
                      search.length === 0 &&
                      value.length > 0
                    ) {
                      event.preventDefault();
                      handleValueRemove(value[value.length - 1]);
                    }
                  }}
                />
              </Combobox.EventsTarget>
            :<Input.Placeholder>{value.length?'':'Pick value'}</Input.Placeholder>}
              
            </Pill.Group>
          </PillsInput>
        </Combobox.DropdownTarget>
  
        <Combobox.Dropdown>
          <Combobox.Options>
            {options.length > 0 ? (
              options
            ) : (
              <Combobox.Empty>Nothing found...</Combobox.Empty>
            )}
          </Combobox.Options>
        </Combobox.Dropdown>
      </Combobox>
    );
  };
  
  export default StatusSelectBox;